// extracted by mini-css-extract-plugin
module.exports = {"result":"styles-module__result___2vSPq","label":"styles-module__label___18M9k"};